"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Button;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const variables_1 = __importDefault(require("../../styles/variables"));
const clsx_1 = __importDefault(require("clsx"));
const ButtonLoadingIndicator_1 = __importDefault(require("./ButtonLoadingIndicator"));
const useStyles = (0, core_1.makeStyles)({
    button: {
        textTransform: 'none',
        fontFamily: variables_1.default.fonts.family.heading,
        fontWeight: variables_1.default.fonts.weight.semiBold,
        paddingLeft: '24px',
        paddingRight: '24px',
        '&:focus-visible': {
            outline: '-webkit-focus-ring-color auto 1px',
            outlineOffset: '3px',
        },
    },
    buttonSmall: {
        paddingTop: '7px',
        paddingBottom: '7px',
        fontSize: variables_1.default.fonts.size.small,
    },
    buttonMedium: {
        paddingTop: '10px',
        paddingBottom: '10px',
        fontSize: variables_1.default.fonts.size.regular,
    },
    buttonLarge: {
        paddingTop: '12px',
        paddingBottom: '12px',
        fontSize: variables_1.default.fonts.size.h5,
    },
    textUppercase: {
        textTransform: 'uppercase',
    },
    rounded: {
        borderRadius: '50px',
    },
    filled: {
        backgroundColor: variables_1.default.colors.action.primary.default,
        color: variables_1.default.colors.text.secondary,
        '&:hover, &:hover.Mui-disabled': {
            // Please keep the above CSS selector, it is important to show correct hover state on mobiles
            backgroundColor: variables_1.default.colors.action.primary.hover,
        },
        '&:active': {
            backgroundColor: variables_1.default.colors.action.primary.pressed,
        },
        '&.Mui-disabled': {
            backgroundColor: variables_1.default.colors.action.primary.disabled,
            color: variables_1.default.colors.text.secondary,
        },
    },
    critical: {
        backgroundColor: variables_1.default.colors.action.critical.default,
        color: variables_1.default.colors.text.secondary,
        '&:hover, &:hover.Mui-disabled': {
            // Please keep the above CSS selector, it is important to show correct hover state on mobiles
            backgroundColor: variables_1.default.colors.action.critical.hover,
        },
        '&:active': {
            backgroundColor: variables_1.default.colors.action.critical.pressed,
        },
        '&.Mui-disabled': {
            backgroundColor: variables_1.default.colors.action.critical.disabled,
            color: variables_1.default.colors.text.secondary,
        },
    },
    outlined: {
        backgroundColor: variables_1.default.colors.action.secondary.default,
        color: variables_1.default.colors.text.default,
        border: `1px solid ${variables_1.default.colors.border.default}`,
        '&:hover, &:hover.Mui-disabled': {
            // Please keep the above CSS selector, it is important to show correct hover state on mobiles
            backgroundColor: variables_1.default.colors.action.secondary.hover,
            border: `1px solid ${variables_1.default.colors.border.default}`,
            boxSizing: 'border-box',
        },
        '&:active': {
            backgroundColor: variables_1.default.colors.action.secondary.pressed,
        },
        '&.Mui-disabled': {
            backgroundColor: variables_1.default.colors.action.secondary.disabled,
            color: variables_1.default.colors.text.default,
        },
    },
});
function Button({ variant = 'contained', onClick, className, children = null, uppercase = false, fullWidth = false, rounded = false, showLoadingIndicator = false, ...props }) {
    const classes = useStyles({});
    const buttonContent = showLoadingIndicator ? (react_1.default.createElement(ButtonLoadingIndicator_1.default, null)) : (children);
    let realVariant;
    if (variant === 'contained' || variant === 'critical') {
        realVariant = 'contained';
    }
    else {
        realVariant = variant === 'outlined' ? 'outlined' : 'text';
    }
    return (react_1.default.createElement(core_1.Button, { onClick: (e) => onClick && onClick(e), disableElevation: true, disableRipple: true, classes: {
            label: (0, clsx_1.default)({ [classes.textUppercase]: uppercase }),
            sizeSmall: classes.buttonSmall,
            sizeLarge: classes.buttonLarge,
            contained: (0, clsx_1.default)({
                [classes.filled]: variant === 'contained',
                [classes.critical]: variant === 'critical',
            }),
            outlined: classes.outlined,
            root: (0, clsx_1.default)([
                classes.button,
                rounded && classes.rounded,
                { [classes.buttonMedium]: props.size === 'medium' },
            ]),
        }, className: className, fullWidth: fullWidth, variant: realVariant, ...props }, buttonContent));
}
